import iconCognitive from '@img/quiz/6-milestones/cognitive.svg';
import iconLanguage from '@img/quiz/6-milestones/language.svg';
import iconMotor from '@img/quiz/6-milestones/motor.svg';
import iconSocial from '@img/quiz/6-milestones/social.svg';
import iconVisual from '@img/quiz/6-milestones/visual.svg';

export const milestoneIcons = {
    'LANGUAGE': iconLanguage,
    'COGNITIVE': iconCognitive,
    'SOCIAL': iconSocial,
    'MOTOR': iconMotor,
    'VISUAL': iconVisual,
}